import { ImmutableMap, propIn } from '../../../common/utils/immutableHelper';
import { getElementId } from '../selectors/elementSelector';
import { ImElementLocalData } from './elementLocalDataTypes';

export const getElementLocalData = (state: ImmutableMap, ownProps: unknown): ImElementLocalData | undefined =>
    propIn(['local', 'elements', getElementId(state, ownProps)], state);
